module.exports = __webpack_public_path__ + "img/schwangerschaft.c8acd3c3.svg";